// extracted by mini-css-extract-plugin
export default {"iconButton":"VolumeControl_iconButton__DHSW+"};